import { render } from "./SenaraiIbayaqTanpaPp.vue?vue&type=template&id=8dd5f192"
import script from "./SenaraiIbayaqTanpaPp.vue?vue&type=script&lang=js"
export * from "./SenaraiIbayaqTanpaPp.vue?vue&type=script&lang=js"

import "./SenaraiIbayaqTanpaPp.vue?vue&type=style&index=0&id=8dd5f192&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__